import { useEffect, useRef } from 'react'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'
import useStudentPreChecks from '../../useStudentPreChecks'
import { ASR_EVENTS } from '../StudentASRConstants'

const MS_TO_FAIL_STUDENT = 12000 // 12 seconds

export default function ASRAfterInitialSpeechTimer(props) {

    const {speechProps, teacherMode, openTeacherModal} = props

    const studentPreCheck = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentASRChecks })

    const overallTimerToForceEnd = useRef()

    useEffect(()=>{

        startOverAllTimer()

        return () => {
            cancelOverAllTimer()
        }

    }, [])

    const startOverAllTimer = () => {
        cancelOverAllTimer()
        overallTimerToForceEnd.current = setTimeout(forceEnd, MS_TO_FAIL_STUDENT)
    }
    const cancelOverAllTimer = () => {
        clearTimeout(overallTimerToForceEnd.current)
    }
    const forceEnd = async () => {
        openTeacherModal()
        if(teacherMode){
            studentPreCheck.logEvent(ASR_EVENTS.TEACHER_TIMED_OUT)
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.teacher_mode_asr_failure_none_worked_one })
        }else{
            studentPreCheck.logEvent(ASR_EVENTS.STUDENT_TIMED_OUT)
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.student_asr_get_teacher })
        }
    }

    return null
}
